import React, { useEffect, useRef } from "react";
import products from "../data/products.json"; // adjust path if needed

const ProductSection = ({ productNumber, onBack }) => {
  const index = parseInt(productNumber, 10) - 1; // convert "01" -> 0
  const product = products[index];

  const folder = `/images/aggregate/${productNumber}`;
  const media = {
    video: `${folder}/1.mp4`,
    images: [`${folder}/2.jpg`, `${folder}/3.jpg`, `${folder}/4.jpg`],
  };

  const videoRef = useRef(null);

  useEffect(() => {
    const handleUnmute = () => {
      if (videoRef.current) {
        videoRef.current.muted = false;
        videoRef.current.play().catch(() => {});
      }
      document.removeEventListener("click", handleUnmute);
    };

    document.addEventListener("click", handleUnmute);
    return () => document.removeEventListener("click", handleUnmute);
  }, []);

  if (!product) return <p>Product not found</p>;

  return (
    <main className="flex w-full gap-x-10">
      {/* Left column fixed */}
      <div className="flex flex-col md:w-1/4 sticky top-0 self-start h-screen ml-10">
        <button
          onClick={onBack}
          className="mb-4 text-sm cursor-pointer uppercase text-left mb-[60px]"
        >
          <p className="mt-1">Back</p>
        </button>

        {/* Product title */}
        <p className="mb-5 font-bold">
          {product.name || `Product ${productNumber}`}
        </p>

        {/* Main product image */}
        <img
          src={media.images[2]}
          alt="Product detail"
          className="w-full h-auto object-cover mb-[60px]"
        />

        {/* Description */}
        <p className="font-bold mb-2">Description</p>
        <p className="mb-5 text-justify">{product.description}</p>

        {/* Product info section */}
        <div className="grid grid-cols-2 gap-2 font-medium">
          <p>Serial:</p>
          <p className="text-right">{product.serial}</p>

          <p>Crafted In:</p>
          <p className="text-right">{product.crafted}</p>

          <p>Composition:</p>
          <p className="text-right">{product.composition}</p>

          <p>Price:</p>
          <p className="text-right">{product.price}</p>

          <p>Size (US):</p>
          <p className="text-right">
            {product.size && product.size.length > 0
              ? product.size.join(", ")
              : "N/A"}
          </p>
        </div>
      </div>

      {/* Right column scrolls with page */}
      <div className="flex flex-col md:w-3/4">
        <video
          ref={videoRef}
          src={media.video}
          autoPlay
          muted
          loop
          playsInline
          className="w-full object-cover"
        />
        <img
          src={media.images[0]}
          alt="Additional image 1"
          className="w-full object-cover"
        />
        <img
          src={media.images[1]}
          alt="Additional image 2"
          className="w-full object-cover"
        />
      </div>
    </main>
  );
};

export default ProductSection;
